import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import muiThemeable from 'material-ui/styles/muiThemeable';

import Header from '../Header/Header';
import Navigation from '../Header/Navigation';
import ProductList from './ProductList';
import ImportForm from './ImportForm';
import CreateProduct from './CreateProduct';
import EditProduct from './EditProduct';

import {
  NavOuter,
  NavContainer
} from '../Styles/index';


const linkItems = [
  {
    to: "/products",
    text: "Products List",
    exact: true
  },
  {
    to: "/products/add",
    text: "Add Product"
  },
  {
    to: "/products/import",
    text: "Import Products"
  }
];

class Products extends Component {
  render() {
    return (
      <div>
        <Header/>
        <NavOuter bg={this.props.muiTheme.palette.primary2Color}>
          <NavContainer>
            <Navigation height={'36px'} darker items={linkItems}></Navigation>
          </NavContainer>
        </NavOuter>
        <Switch>
          <Route exact path="/products" component={ProductList}/>
          <Route path="/products/add" component={CreateProduct}/>
          <Route path="/products/edit" component={EditProduct}/>
          <Route path="/products/import" component={ImportForm}/>
        </Switch>
      </div>
    );
  }
}



export default muiThemeable()(Products);



// WEBPACK FOOTER //
// ./src/components/Products/index.js